<button type="button" class="close" aria-label="Close" (click)="close()">
  <span> <img src="/./assets/tfb-acctmgmt/images/icons/close-icon.png" alt=""></span>
</button>

<div class="serviceSection">
  <div class="col-12 selectServHeading">{{authoringContentData?.selectServices}}</div>
  <div class="col-12 subHeading1">Please select the services for your bulk request</div>
  <div class="col-12 subHeading2">Changes will go into effect in your next billing cycle.</div>
<mat-divider class="topDivider"></mat-divider>

<mat-accordion class="serviceCollapse">
  <div>
    <mat-expansion-panel #expPanel1>
      <mat-expansion-panel-header (click)="expPanel1.expanded?onExpand(authoringContentData?.dataServices):onCollapse(authoringContentData?.dataServices)">
        <mat-panel-title class="groupName">{{authoringContentData?.dataServices}}</mat-panel-title>
      </mat-expansion-panel-header>
      <!--Table section-->
      <div class="col-12">
        <div class="tmobilelistingtable-head row">
        </div>
        <div class="error_msg row" *ngIf="dataServices.length == 0">
          {{authoringContentData?.dataSvcUnavailable}}
        </div>
        <div class="tableContents row" *ngFor="let service of dataServices">
          <div class="col-9 tableRow tableData">
            <div class="col-12">
              <div class="row">
                <div>
                  <mat-checkbox [(ngModel)]="service.isSelected" (change)="checkServiceSelection(service)"></mat-checkbox>
                </div>
                <div class="col-9 serviceName">
                  {{ service.skuName }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 tableRow tableData">
            <div class="viewDetails" (click)="openViewDetailsModal(service)">
              {{authoringContentData?.viewDetails}}
            </div>
          </div>
        </div>
      </div>
      <!--Table section-->
    </mat-expansion-panel>
    <mat-divider></mat-divider>
  </div>
  <div>
    <mat-expansion-panel #expPanel2>
      <mat-expansion-panel-header (click)="expPanel2.expanded?onExpand(authoringContentData?.blockServices):onCollapse(authoringContentData?.blockServices)">
        <mat-panel-title class="groupName">{{authoringContentData?.blockServices}}</mat-panel-title>
      </mat-expansion-panel-header>
      <!--Table section-->
      <div class="col-12">
        <div class="tmobilelistingtable-head row">
          <div class="header col-2"></div>
        </div>
        <div class="error_msg row" *ngIf="blockServices.length == 0">
          {{authoringContentData?.blockSvcUnavailable}}
        </div>
        <div class="tableContents row" *ngFor="let service of blockServices">
          <div class="col-9 tableRow tableData">
            <div class="col-12">
              <div class="row">
                <div>
                <mat-checkbox [(ngModel)]="service.isSelected" (change)="checkServiceSelection(service)"></mat-checkbox>
              </div>
                <div class="col-9 serviceName">
                  {{ service.skuName }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 tableRow tableData">
            <div class="viewDetails" (click)="openViewDetailsModal(service)">
              {{authoringContentData?.viewDetails}}
            </div>
          </div>
        </div>
      </div>
      <!--Table section-->
    </mat-expansion-panel>
    <mat-divider></mat-divider>
  </div>
  <div>
    <mat-expansion-panel #expPanel3>
      <mat-expansion-panel-header (click)="expPanel3.expanded?onExpand(authoringContentData?.otherServices):onCollapse(authoringContentData?.otherServices)">
        <mat-panel-title class="groupName">{{authoringContentData?.otherServices}}</mat-panel-title>
      </mat-expansion-panel-header>
      <!--Table section-->
      <div class="col-12">
        <div class="tmobilelistingtable-head row">
          <div class="header col-2"></div>
        </div>
        <div class="error_msg row" *ngIf="otherServices.length == 0">
          {{authoringContentData?.otherSvcUnavailable}}
        </div>
        <div class="tableContents row" *ngFor="let service of otherServices">
          <div class="col-9 tableRow tableData">
            <div class="col-12">
              <div class="row">
                <div>
                <mat-checkbox [(ngModel)]="service.isSelected" (change)="checkServiceSelection(service)"></mat-checkbox>
              </div>
                <div class="col-9 serviceName">
                  {{ service.skuName }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 tableRow tableData">
            <div class="viewDetails" (click)="openViewDetailsModal(service)">
              {{authoringContentData?.viewDetails}}
            </div>
          </div>
        </div>
      </div>
      <!--Table section-->
    </mat-expansion-panel>
    <mat-divider></mat-divider>
  </div>
</mat-accordion>

<!-- Technical Error Modal -->
<ng-template #technicalDifficulties class="modal fade in" let-c="close" let-d="dismiss">
  <div class="militaryTechErr">
    <div class="modal-header justify-content-start">
      <img src="/./assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-15 errorIcon" alt="">
      <h4 class="modal-title mt-0" id="modal-basic-title">{{errorModalContent?.militaryTechnicalError?.errModalTitle}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="errorCloseButtonTagging()">
      <span> <img src="/./assets/tfb-acctmgmt/images/icons/close-icon.png" alt=""></span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row m-0">
        <div class="addGroup-label">
          <p class="errBodyTxt">{{errorModalContent?.militaryTechnicalError?.errMessageBodyTxt}}</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="modal-footer justify-content-end">
  <div class="button-row">
    <button class="btn primary_btn ok-btn" [ngClass]="{'isDisabled': currentSelectedServices.length === 0 }" (click)="downloadChangeServiceFile()">Download Template</button>
  </div>
</div>
